module.exports = __webpack_public_path__ + "assets/97d78786c92dd9cf631f3b24b9918cbc.png";